var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CInfoPageTemplate,{attrs:{"content-label":_setup.getLeaveWordTitle,"content-text":_setup.getLeaveWordTips,"button-text":_vm.$t('enterprise.leave-word.action-button')},on:{"button-click":_setup.goLeaveWord}})
}
var staticRenderFns = []

export { render, staticRenderFns }